import loginRoutes from '@/containers/Login';
import invitationRoutes from '@/containers/Invitation';

import NotFoundComponent from '@/components/NotFound';
const routes = [
	...loginRoutes,
	...invitationRoutes,
	{
		path: '/',
		redirect: '/authorize'
	},
	{
		path: '*',
		component: NotFoundComponent
	}
];

export default routes;
